import { RootState } from 'handlers';

export const getAIChat = ({ aiChat }: RootState) => aiChat;
